<template>
    <section class="section">
        <div class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <h1 class="title">Checkrides</h1>
                </div>
            </div>
            <div class="level">
                <div v-if="errorMessage" class="notification is-danger">
                    {{ errorMessage }}
                </div>
            </div>
        </div>
        
        <!-- Responsive Layout -->
        <div class="columns is-desktop">
            <!-- Left Column: Forms (Desktop) / Top (Mobile) -->
            <div class="column is-desktop-6">
                <!-- New 299 Form -->
                <New299Form @success="handleCheckride299Success" @error="handleError" />

                <!-- New 293 Form -->
                <New293Form @success="handleCheckride293Success" @error="handleError" />
            </div>

            <!-- Right Column: History (Desktop) / Bottom (Mobile) -->
            <div class="column is-desktop-6">
                <!-- Checkride History -->
                <CheckrideHistory 
                    :checkrides="checkrides.checkrides" 
                    @view-checkride="openCheckrideModal" 
                />
            </div>
        </div>

        <!-- Checkride Details Modal -->
        <CheckrideModal 
            :isOpen="isModalOpen" 
            :checkride="selectedCheckride" 
            @close="closeModal" 
        />
    </section>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useCheckrides } from '@/lib/checkrides';
import New299Form from './New299Form.vue';
import New293Form from './New293Form.vue';
import CheckrideHistory from './CheckrideHistory.vue';
import CheckrideModal from './CheckrideModal.vue';

export default {
    name: 'CheckridesView',
    components: {
        New299Form,
        New293Form,
        CheckrideHistory,
        CheckrideModal
    },
    setup() {
        const errorMessage = ref(null);
        const isModalOpen = ref(false);
        const selectedCheckride = ref(null);
        
        // Get checkrides library
        const checkrides = useCheckrides();
        
        // Initialize checkrides data
        onMounted(async () => {
            try {
                // Initialize checkrides library
                checkrides.initialize();
                
                // Fetch checkrides using the checkrides library
                await checkrides.fetchCheckrides();
            } catch (error) {
                console.error('Error initializing checkrides:', error);
                errorMessage.value = "Failed to load checkrides data. Please try again.";
            }
        });

        const handleCheckride299Success = async (checkride) => {
            console.log('299 Checkride created successfully:', checkride);
            errorMessage.value = null;
            
            // Refresh the checkrides list to show the new entry
            await checkrides.fetchCheckrides();
        };

        const handleCheckride293Success = async (checkride) => {
            console.log('293 Checkride created successfully:', checkride);
            errorMessage.value = null;
                    
                    // Refresh the checkrides list to show the new entry
                    await checkrides.fetchCheckrides();
        };

        const handleError = (error) => {
            errorMessage.value = error;
        };

        const openCheckrideModal = (checkride) => {
            selectedCheckride.value = checkride;
            isModalOpen.value = true;
        };

        const closeModal = () => {
            isModalOpen.value = false;
            selectedCheckride.value = null;
        };

        return {
            errorMessage,
            checkrides,
            isModalOpen,
            selectedCheckride,
            handleCheckride299Success,
            handleCheckride293Success,
            handleError,
            openCheckrideModal,
            closeModal
        };
    }
};
</script>

<style scoped>
/* Responsive layout styles */
.columns.is-desktop {
    margin-top: 1rem;
}

/* Add spacing between forms on desktop */
.column.is-desktop-6 > * + * {
    margin-top: 1.5rem;
}

/* Ensure proper spacing on mobile */
@media screen and (max-width: 1399px) {
    .columns.is-desktop {
        display: block;
    }
    
    .column.is-desktop-6 {
        width: 100%;
        margin-bottom: 1.5rem;
    }
}

/* Desktop specific styles */
@media screen and (min-width: 1400px) {
    .columns.is-desktop {
        display: flex;
        gap: 1.5rem;
    }
    
    .column.is-desktop-6 {
        flex: 1;
    }
}
</style>
